import { Box, Typography, Tab, Tabs } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "components/@extended/Breadcrumbs";
import MainCard from "components/MainCard";
import TabPersonal from "pages/settings/tabs/TabProfile";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import ChangePasswordData from "pages/settings/tabs/TabChangePassword";
import { NavItemType } from "types/menu";
  
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
        >
        {value === index && (
            <Box>
            <Typography>{children}</Typography>
            </Box>
        )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function SettingsPage() {
    const { t } = useTranslation();

    const [value, setValue] = React.useState(0);
    const breadcrumbNavigation = React.useMemo<{ items: NavItemType[] }>(
        () => ({
            items: [
                {
                    id: 'group-profile',
                    type: 'group',
                    children: [
                        {
                            id: 'item-profile',
                            title: t('settings', 'Settings'),
                            type: 'item',
                            url: '/profile'
                        }
                    ]
                }
            ]
        }),
        [t]
    );

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    };

    return (
        <>
            <Breadcrumbs navigation={breadcrumbNavigation} title titleBottom card={false} divider={false} />
            <Box sx={{ width: '100%' }}>
                <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto" aria-label="account profile tab">
                    <Tab label={t('profile', 'Profile')} icon={<UserOutlined />} iconPosition="start" sx={{textTransform: 'none'}} {...a11yProps(0)}/>
                    <Tab label={t('change_password', 'Change password')} icon={<LockOutlined />} iconPosition="start" sx={{textTransform: 'none'}} {...a11yProps(1)}/>
                </Tabs>
            </Box>
            <MainCard sx={{ mt: 2.5 }}>
                <CustomTabPanel value={value} index={0}>
                    <TabPersonal/>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <ChangePasswordData/>
                </CustomTabPanel>
            </MainCard>
        </>
    );
}